import { STAFF_COLOR } from 'shared/consts';
import styled, { css } from 'styled-components';

export const Timeslot = styled.div`
	position: absolute;
	bottom: 30px;
	padding: 0px 24px;
	cursor: pointer;
	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
`;

export const Container = styled.div<{$isLast?: boolean}>`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	gap: 3px;
	cursor: pointer;

	${props => !props.$isLast && css`border-right: 1px solid ${STAFF_COLOR};`}
	
	padding-right: 8px;
	margin-top: -35px;
	min-height: 28px;
	padding-top: 35px;
`;
